<script lang="ts" setup>
import { computed, PropType } from 'vue'

import { IconOptions, SizeOptions } from '@/types'

const ICONS = import.meta.glob('../../assets/svg/icons/*.svg', { eager: true })

const props = defineProps({
  icon: { type: String as PropType<IconOptions>, required: true },
  size: { type: String as PropType<SizeOptions>, default: 'xs' }
})

const iconSvg = computed(() => ICONS[`../../assets/svg/icons/${props.icon}.svg`])
</script>

<template>
  <component
    :is="iconSvg"
    :class="{
      'w-4 h-4': size === 'xs',
      'w-6 h-6': size === 'sm',
      'w-7 h-7': size === 'md',
      'w-8 h-8': size === 'lg'
    }"
  />
</template>
